import { render, staticRenderFns } from "./notwechatbrowse.vue?vue&type=template&id=0fe7ad44"
import script from "./notwechatbrowse.vue?vue&type=script&lang=js"
export * from "./notwechatbrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports